import React, { useContext, useEffect, useMemo } from "react";
import "@/assets/css/customwidget.css";
import Button from "react-bootstrap/Button";
import styles from "@/page-components/cost-explorer/components/edit-widget/edit-widget.module.css";
import { FilterSearch } from "@/components/filter-search/filter-search";
import clsx from "clsx";
import includeIcon from "@/assets/img/include.svg";
import excludeIcon from "@/assets/img/exclude.svg";
import { ReactComponent as AddIcon } from "@/assets/img/add.svg";
import { ReactComponent as RemoveIcon } from "@/assets/img/filter-delete.svg";
import Tooltip from "@/components/tooltip/tooltip";
import { useTagValues } from "@/services/costExplorer/getDimensionTags.repo";
import { useTagValuesCost } from "@/services/cost-anomaly/get-tags.repo";
import { AnomalyContext } from "../cost-anomaly.context";

/**
 * @typedef {import('@/services/costExplorer/addCostExplorerWidget.repo').AddCostExplorerWidgetReq} AddCostExplorerWidgetReq
 */

/**
 * @typedef TagItemProps
 * @param {import('react-hook-form').FieldArrayWithId<AddCostExplorerWidgetReq, "tags", "id">} field
 */

const TagItem = ({
  service,
  field,
  watch,
  setValue,
  append,
  remove,
  watchCloud,
  errors,
  index,
  dimensionKeys,
}) => {
     const context = useContext(AnomalyContext);
  const watchTags = watch(`tags`);
  const watchFilterType = watch(`tags.${index}.filterType`);
  const watchFilterOn = watch(`tags.${index}.filterOn`);
  const watchValues = watch(`tags.${index}.values`);
  const { data: dimensionValues, isLoading } = useServiceDimensionTags(
    service,
    watchFilterOn
  );
  // const filteredValues =
  //   (watchValues || []).map((e) => ({
  //     id: e,
  //     name: e,
  //   })) || [];
  const filteredValues = useMemo(() => {
    if (!watchValues || !Array.isArray(watchValues)) return [];
  
    return watchValues.map((val) => {
      const match = (dimensionValues?.data || []).find((d) => d.id === val || d.name === val);
      return match || { id: val, name: val }; 
    });
  }, [dimensionValues, watchValues]);
    useEffect(() => {
      const newId = filteredValues.length > 0 ? filteredValues[0].id : "";
    
      if (newId !== context?.selectedID) {
        context?.setSelectedID(newId);
      }
    }, [filteredValues, context]);
  

  const selectedFilterDimensions = useMemo(() => {
    return watchTags.map((e) => e.filterOn);
  }, [watchTags]);

  return (
    <>
      <div className={styles.filter_select_div}>
        <div className={styles.filter_select_css}>
          <div className="w-100">
            <FilterSearch
              // options={dimensionKeys}
              options={dimensionKeys?.filter(
                (tagLabel) => !selectedFilterDimensions.includes(tagLabel.id)
              )}
              displayValue="name"
              selectedValues={[watchFilterOn]}
              searchFieldPlaceholder={"Filter Grouping"}
              onSelect={(selectedItem) => {
                setValue(`tags.${index}.filterOn`, selectedItem.id);
                setValue(`tags.${index}.filterType`, "include");
                setValue(`tags.${index}.values`, []);
              }}
              toggle={
                <div
                  style={{
                    background: "filter_dimension_toggle",
                    color: "#797B80",
                    backgroundColor:
                      filteredValues.length >= 1 ? "" : "#F8F9FA",
                  }}
                  className={clsx(styles.filter_dimension_toggle, {
                    [styles.filter_dimension_toggle_selected]:
                      watchFilterOn?.length > 0,
                  })}
                >
                  {watchFilterOn ? watchFilterOn : "Add Tags"}
                </div>
              }
            />
          </div>
          {/* {watchFilterOn?.length > 0 && (
            <Tooltip
              tooltipContent="Remove"
              overlayProps={{ placement: "bottom-end" }}
            >
              {(_show, setShow) => (
                <Button
                  variant="link"
                  className={clsx("p-0", styles.remove_icon)}
                  onMouseEnter={() => setShow(true)}
                  onMouseLeave={() => setShow(false)}
                  onClick={() => {
                    remove(index);

                    if (watchTags.length === 1) {
                      append({
                        filterOn: "",
                        filterType: "include",
                        values: [],
                      });
                    }
                  }}
                >
                  <RemoveIcon />
                </Button>
              )}
            </Tooltip>
          )} */}
        </div>
        <div className="d-block w-100">
          <FilterSearch
            // multiselect
            searchFieldPlaceholder="Filter Service"
            options={(dimensionValues?.data || []).map((e) => ({
              id: e?.id || "null",
              name: e.name || "null",
            }))}
            displayValue="name"
            loading={isLoading}
            selectedValues={filteredValues}
            onSelect={(selectedItem) => {
              setValue(`tags.${index}.values`, [selectedItem.id]);
            }}
            disabled={!watchFilterOn?.length}
            toggle={
              <div className="hstack gap-1 mt-1">
                {filteredValues?.length === 0 && (
                  <span
                    className={clsx(styles.placeholder_text_filter)}
                    style={{ paddingLeft: "8px", color: "#797B80" }}
                  >
                    Choose Values
                  </span>
                )}
                {filteredValues?.length >= 1 && (
                  <span className={clsx(styles.chip, "w-100 gap-2 d-flex")}>
                    <span
                      style={{
                        overflow: "hidden",
                        maxWidth: "300px",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                      }}
                      title={filteredValues.map((e) => e.name)}
                    >
                      {filteredValues
                        .slice(0, 1)
                        .map((e) => e.name || null)
                        .join(", ")}
                    </span>
                    {filteredValues.length > 1 && (
                      <span>+{filteredValues.length - 1}</span>
                    )}
                  </span>
                )}
              </div>
            }
          />
        </div>
        {/* {errors.tags && errors.tags[index].values && (
          <small className="error-message text-left mb-1 mx-4">
            * {errors.tags[index].values.message}
          </small>
        )}
        {errors.tags && errors.tags[index].dimension && (
          <small className="error-message text-left mb-1 mx-4">
            * {errors.tags[index].dimension.message}
          </small>
        )} */}
      </div>
    </>
  );
};

/**
 *
 * @param {'aws' | 'azure' | 'gcp'} service
 * @param {string} columnName
 */
const useServiceDimensionTags = (service, columnName) => {
  const {
    data: values,
    refetch: fetchValues,
    isLoading,
  } = useTagValuesCost({
    columnName,
    service,
  });
  useEffect(() => {
    if (service && columnName) {
      fetchValues();
    }
  }, [columnName, fetchValues, service]);
  return { data: values || [], isLoading };
};

export default TagItem;
